import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'majorUnit' })
export class MajorUnitPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let defaultValue = null;

    if (args !== undefined) {
      defaultValue = args;
    }
    return value ? Math.round(value) / 100 : defaultValue;
  }
}
